<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('destinations')" :icon="'navigation'" />
            </div>
            <div v-if="$can('create_destinations')" class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" @click="openAddEditModal">
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <destination-add-edit-modal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="destination-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";

export default {
    extends: CoreLibrary,
    name: "AppDestinations",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'destinations-table',
            rowData: {},
            options: {
                name: 'AppDestinations',
                url: actions.DESTINATION,
                showHeader: true,
                enableHighlights: true,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                    },
                    {
                        title: this.$t('latitude'),
                        type: 'custom-html',
                        key: 'latitude',
                        modifier: (value) => this.formatCoordinate(value),
                    },
                    {
                        title: this.$t('longitude'),
                        type: 'custom-html',
                        key: 'longitude',
                        modifier: (value) => this.formatCoordinate(value),
                    },
                    {
                        title: this.$t('trips_count'),
                        type: 'custom-html',
                        key: 'trips_count',
                        modifier: (value) => `<span>${value || 0}</span>`,
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        modifier: () => this.$can('update_destinations'),
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        modifier: () => this.$can('delete_destinations'),
                    }
                ],
                showFilter: false,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        };
    },
    methods: {
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        closeAddEditModal() {
            $("#destination-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.resetData();
        },
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.icon === 'trash') {
                this.openDeleteModal();
            }

            if (actionObj.icon === 'edit') {
                this.selectedUrl = `${actions.DESTINATION}/${rowData.id}`;
                this.openAddEditModal();
            }
        },
        confirmed() {
            this.deleteLoader = true;

            this.axiosDelete(`${actions.DESTINATION}/${this.rowData.id}`)
                .then((response) => {
                    $("#destination-delete").modal('hide');
                    this.$toastr.s(response.data.message);
                    this.cancelled();
                    this.refreshDependencies();
                }).catch(({ response }) => {
                    this.$toastr.e(response?.data?.message || this.$t('action_not_allowed'));
                }).finally(() => {
                    this.deleteLoader = false;
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.resetData();
        },
        resetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        refreshDependencies() {
            this.$store.dispatch('getDestinations');
        },
        formatCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return '---';
            }

            return Number(value).toFixed(6);
        },
    },
}
</script>
